import React, { ReactElement } from 'react';
import TableCell from '../../../components/table-cell/table-cell.component';
import Checkbox from '../../../components/checkbox/checkbox.component';
import LongClickTableRow from '../../../components/long-click-table-row/long-click-table-row.component';
import FilteredCell from '../../../components/filtered-cell/filtered-cell.component';
import VisibleCell from '../../../components/visible-cell/visible-cell.component';
import AssetRowForm from '../asset-row-form/asset-row-form.component';
import useScreenSmall from '../../../hooks/use-screen-small';

const AssetRow: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const ID_PREFIX_CHECKBOX_EXPORT: string = 'checkbox-export';

  const {
    isActive,
    isSaving,
    isSaveDisabled,
    isInlineSaving,
    isSelected,
    isEditMode,
    isExportMode,
    isSelectMode,
    isCustomizeMode,
    isMultiplePortfolioGroupView,
    assetItem,
    assetIndex,
    portfolioItem,
    assetPhotoFile,
    currentUser,
    inputRefs,
    tableName,
    tableColumnSettings,
    tableAssetListFields,
    fileDropDeps,
    assetStatusList,
    measureUnitList,
    pricingTypeList,
    portfolioList,
    assetTypeList,
    contactCompanyList,
    tagList,
    assetOwnershipStructureTypeList,
    onRowClick,
    onLongClick,
    onInlineSave,
    onInlineCancel,
    onAssetPhotoChange,
    onAssetPhotoDelete,
    onAddressSearchCompleted,
    onAddressFieldKeyDown,
    onAssetTypesChange,
    onAssetSellersChange,
    onTagsChange,
    onContactCompanySearch,
    onContactCompanySearchClose,
    onTagSearch,
    onTagSearchClose,
  } = props;

  const isSmallScreen: boolean = useScreenSmall();

  return (
    isEditMode && isActive ? (
      <AssetRowForm
        isActive={isActive}
        isSaving={isSaving}
        isSaveDisabled={isSaveDisabled}
        isInlineSaving={isInlineSaving}
        isMultiplePortfolioGroupView={isMultiplePortfolioGroupView}
        assetIndex={assetIndex}
        assetData={assetItem}
        portfolioData={portfolioItem}
        currentUser={currentUser}
        assetPhotoFile={assetPhotoFile}
        inputRefs={inputRefs}
        fileDropDeps={fileDropDeps}
        tableColumnSettings={tableColumnSettings}
        assetStatusList={assetStatusList}
        measureUnitList={measureUnitList}
        pricingTypeList={pricingTypeList}
        portfolioList={portfolioList}
        assetTypeList={assetTypeList}
        contactCompanyList={contactCompanyList}
        assetOwnershipStructureTypeList={assetOwnershipStructureTypeList}
        tagList={tagList}
        onInlineSave={onInlineSave}
        onInlineCancel={onInlineCancel}
        onAssetPhotoChange={onAssetPhotoChange}
        onAssetPhotoDelete={onAssetPhotoDelete}
        onAddressSearchCompleted={onAddressSearchCompleted}
        onAddressFieldKeyDown={onAddressFieldKeyDown}
        onAssetTypesChange={onAssetTypesChange}
        onAssetSellersChange={onAssetSellersChange}
        onTagsChange={onTagsChange}
        onContactCompanySearch={onContactCompanySearch}
        onContactCompanySearchClose={onContactCompanySearchClose}
        onTagSearch={onTagSearch}
        onTagSearchClose={onTagSearchClose}
      />
    ) : (
      <LongClickTableRow
        isActive={isSelected}
        isButton={!isCustomizeMode}
        onClick={(event: React.MouseEvent<Element, MouseEvent>): void => {
          onRowClick(event, portfolioItem.id, assetItem.id);
        }}
        onLongClick={(event: React.MouseEvent<Element, MouseEvent>): void => {
          onLongClick(event, portfolioItem.id, assetItem.id);
        }}
      >
        {
          (isExportMode || isSelectMode) && (
            <TableCell isSticky isStickyLeft>
              <Checkbox
                isChecked={isSelected}
                withNoPadding={!isSmallScreen}
                id={`${ID_PREFIX_CHECKBOX_EXPORT}-${assetItem.id}`}
              />
            </TableCell>
          )
        }
        {
          tableAssetListFields.map((tableField: TableField): ReactElement | boolean => (
            <VisibleCell isEditMode={isEditMode} key={tableField.id} tableField={tableField}>
              {
                !!tableField.component && (
                  !tableField.isNotFiltered ? (
                    <FilteredCell tableName={tableName} columnName={tableField.name} currentUser={currentUser}>
                      {tableField.component(assetItem)}
                    </FilteredCell>
                  ) : (
                    tableField.component(assetItem)
                  )
                )
              }
            </VisibleCell>
          ))
        }
      </LongClickTableRow>
    )
  );
});

export default AssetRow;
